customElements.get('recipient-form') ||
  customElements.define(
    'recipient-form',
    class extends HTMLElement {
      constructor() {
        super(),
          (this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${this.dataset.sectionId}`)),
          (this.checkboxInput.disabled = !1),
          (this.hiddenControlField = this.querySelector(`#Recipient-Control-${this.dataset.sectionId}`)),
          (this.hiddenControlField.disabled = !0),
          (this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`)),
          (this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`)),
          (this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`)),
          (this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper')),
          (this.errorMessageList = this.errorMessageWrapper && this.errorMessageWrapper.querySelector('ul')),
          (this.errorMessage = this.errorMessageWrapper && this.errorMessageWrapper.querySelector('.error-message')),
          (this.defaultErrorHeader = this.errorMessage && this.errorMessage.innerText),
          (this.currentProductVariantId = this.dataset.productVariantId),
          (this.productId = this.dataset.productId),
          (this.fields = this.querySelector('.m-recipient-form__fields')),
          this.addEventListener('change', this.onChange.bind(this))
      }
      cartUpdateUnsubscriber = void 0
      variantChangeUnsubscriber = void 0
      cartErrorUnsubscriber = void 0
      connectedCallback() {
        ;(this.cartUpdateUnsubscriber = window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (e) => {
          this.resetRecipientForm()
        })),
          (this.variantChangeUnsubscriber = window.MinimogEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, (e) => {
            this.currentProductVariantId = e.id
          })),
          (this.cartUpdateUnsubscriber = window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartError, (e) => {
            'product-form' === e.source &&
              e.productVariantId.toString() === this.currentProductVariantId &&
              this.displayErrorMessage(e.message, e.errors)
          }))
      }
      disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(),
          this.variantChangeUnsubscriber && this.variantChangeUnsubscriber(),
          this.cartErrorUnsubscriber && this.cartErrorUnsubscriber()
      }
      onChange() {
        this.checkboxInput.checked || (this.clearInputFields(), this.clearErrorMessage())
      }
      displayErrorMessage(e, r) {
        this.clearErrorMessage()
        if ((Object.keys(r).length > 1 && (this.errorMessageWrapper.hidden = !1), 'object' == typeof r))
          return (
            (this.errorMessage.innerText = this.defaultErrorHeader),
            Object.entries(r).forEach(([e, r]) => {
              const t = `RecipientForm-${e}-error-${this.dataset.sectionId}`,
                s = `#Recipient-${e}-${this.dataset.sectionId}`,
                i = this.querySelector(`${s}`),
                a = `${(i && i.getAttribute('placeholder')) || e} ${r}`,
                n = this.querySelector(`#${t}`),
                c = n && n.querySelector('.error-message')
              if (!c) return
              this.errorMessageList && this.errorMessageList.appendChild(this.createErrorListItem(s, a)),
                (c.innerText = `${a}.`),
                n.classList.remove('m:hidden')
              const o = this[`${e}Input`]
              o && (o.setAttribute('aria-invalid', !0), o.setAttribute('aria-describedby', t))
            })
          )
        this.errorMessage.innerText = r
      }
      createErrorListItem(e, r) {
        const t = document.createElement('li'),
          s = document.createElement('a')
        return s.setAttribute('href', e), (s.innerText = r), t.appendChild(s), (t.className = 'error-message'), t
      }
      clearInputFields() {
        ;(this.emailInput.value = ''), (this.nameInput.value = ''), (this.messageInput.value = '')
      }
      clearErrorMessage() {
        ;(this.errorMessageWrapper.hidden = !0),
          this.errorMessageList && (this.errorMessageList.innerHTML = ''),
          this.querySelectorAll('.m-recipient-form__fields .form-field--message').forEach((e) => {
            e.classList.add('m:hidden')
            const r = e.querySelector('.error-message')
            r && (r.innerText = '')
          }),
          [this.emailInput, this.messageInput, this.nameInput].forEach((e) => {
            e.setAttribute('aria-invalid', !1), e.removeAttribute('aria-describedby')
          })
      }
      resetRecipientForm() {
        this.checkboxInput.checked &&
          ((this.checkboxInput.checked = !1),
          this.fields.classList.remove('show'),
          this.clearInputFields(),
          this.clearErrorMessage())
      }
    }
  )
